import Nullstack from 'nullstack';
export default function IconServer2({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-server-2",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "3",
    y: "4",
    width: "18",
    height: "8",
    rx: "3"
  }), "   ", Nullstack.element("rect", {
    x: "3",
    y: "12",
    width: "18",
    height: "8",
    rx: "3"
  }), "   ", Nullstack.element("line", {
    x1: "7",
    y1: "8",
    x2: "7",
    y2: "8.01"
  }), "   ", Nullstack.element("line", {
    x1: "7",
    y1: "16",
    x2: "7",
    y2: "16.01"
  }), "   ", Nullstack.element("path", {
    d: "M11 8h6"
  }), "   ", Nullstack.element("path", {
    d: "M11 16h6"
  }), " ");
}